export default {
    init() {
        const elements = document.querySelectorAll('[data-animated-in-viewport]');
        elements.forEach((element) => {
            this.elementInViewport(element);

            document.addEventListener('scroll', () => {
                this.elementInViewport(element);
            });
        });
    },

    elementInViewport(element) {
        const bounding = element.getBoundingClientRect();
        const myElementHeight = element.offsetHeight;
        const myElementWidth = element.offsetWidth;

        if (bounding.top >= -myElementHeight
            && bounding.left >= -myElementWidth
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
            && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {
            element.classList.add('in-viewport');
        }
    },
};
